import React, {  useEffect } from 'react';
import { connect,useDispatch } from 'react-redux';
import { compose } from 'redux';
import {getDataOnRequest} from '../redux/actions/CommonActions'
import { toast } from 'react-toastify';
const DriverDetailContainer = (OriginalComponent) => {
  const NewComponent = (props) => {
    const dispatch = useDispatch();
    useEffect(()=>{
      toast.dismiss();
      if(props.userAuth.users_access_token && Object.keys(props.driverDetails).length === 0)
        dispatch(getDataOnRequest(props.userAuth.users_access_token,'SetDriverDetails','SET_DRIVER_DETAILS'))
          
    }, [props.userAuth.users_access_token, props.driverDetails, dispatch]);

    return (
      <OriginalComponent {...props}  />
    )
  }
  return NewComponent
}

const mapStateToProps = (state) => {
  return {
    driverDetails:state.driverDetails.driverDetails,
    userAuth:state.auth.authUserData,
    userInfo:state.userProfile.userData
  };
};

const composedDriverDetailContainer = compose(connect(mapStateToProps), DriverDetailContainer)
export default composedDriverDetailContainer;

